var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./app.css";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import { socket } from "api";
import axios from "axios";
import { messages } from "const/locales/message";
import { GlobalDataEngine } from "context";
import { IntlProvider } from "react-intl";
import { useLocaleStore } from "store/localeStore";
import i18n from "./i18n";
import { i18nToLocale } from "./locales/i18nLocaleMap";
import { LOCALES } from "./locales/locales";
import { AppRouter } from "./router";
function App() {
    var _this = this;
    var locale = useLocaleStore(function (state) { return state.locale; });
    var setLocale = useLocaleStore(function (state) { return state.setLocale; });
    var _a = useState({
        next_btn: "",
    }), localeMessages = _a[0], setLocaleMessages = _a[1];
    useEffect(function () {
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setLocaleMessages(messages[locale] || messages[LOCALES.ENGLISH]);
    }, [locale]);
    useEffect(function () {
        var _a;
        var syncToStore = function (lang) {
            var _a;
            var shortCode = lang.split("-")[0];
            var mapped = (_a = i18nToLocale[shortCode]) !== null && _a !== void 0 ? _a : LOCALES.ENGLISH;
            setLocale(mapped);
        };
        syncToStore((_a = i18n.resolvedLanguage) !== null && _a !== void 0 ? _a : i18n.language);
        i18n.on("languageChanged", syncToStore);
        return function () {
            i18n.off("languageChanged", syncToStore);
        };
    }, [setLocale]);
    useEffect(function () {
        var recordVisit = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.get("".concat(process.env.REACT_APP_API_URL, "/visits/record"))];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error("Error recording visit:", error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        recordVisit();
    }, []);
    useEffect(function () {
        socket.connect();
        return function () {
            socket.disconnect();
        };
    }, []);
    return (_jsxs(IntlProvider, { messages: localeMessages, locale: locale, defaultLocale: LOCALES.ENGLISH, children: [_jsx(GlobalDataEngine, {}), _jsx(AppRouter, { currentLocale: locale, onLocaleChange: setLocale })] }));
}
export default App;
